import type { FirebaseApp } from 'firebase/app';

let firebaseApp: FirebaseApp | null = null;

export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
}

function readConfig(): FirebaseConfig | null {
  const env = import.meta.env;
  const config: FirebaseConfig = {
    apiKey: env.VITE_FIREBASE_API_KEY ?? '',
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
    projectId: env.VITE_FIREBASE_PROJECT_ID ?? '',
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
    messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
    appId: env.VITE_FIREBASE_APP_ID ?? '',
    measurementId: env.VITE_FIREBASE_MEASUREMENT_ID ?? '',
  };
  if (!config.apiKey || !config.projectId || !config.appId) return null;
  return config;
}

export function getFirebaseConfig(): FirebaseConfig | null {
  return readConfig();
}

export function isFirebaseConfigured(): boolean {
  return readConfig() !== null;
}

export async function getFirebaseApp(): Promise<FirebaseApp> {
  if (firebaseApp) return firebaseApp;
  const config = readConfig();
  if (!config) {
    throw new Error(
      'Firebase nie jest skonfigurowany. Skopiuj .env.example do .env i uzupełnij dane projektu Firebase.',
    );
  }
  const { initializeApp, getApps, getApp } = await import('firebase/app');
  firebaseApp = getApps().length > 0 ? getApp() : initializeApp(config);
  return firebaseApp;
}
